import { useDispatch } from 'react-redux';

import { AttachmentInformation } from '@app/features/apply-react-signing/libs/getAttachedAttachments';
import workspaceService from '@app/libs/workspaceService';
import { modalOpen } from '@app/store/modal/actions';
import { getDocumentsAttachment } from '@app/store/transport-layer/document/documents/attachments';
import { downloadFileFromURL, openFileFromURL } from '@app/store/transport-layer/files';

export function useDocumentAttachmentFile() {
  const dispatch = useDispatch();

  async function openDocumentAttachmentFile(attachment: AttachmentInformation) {
    const response = await getDocumentsAttachment({
      workspaceId: workspaceService.getWorkspaceId(),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      documentId: attachment.documentId!,
      attachmentId: attachment.id,
    });

    const file = response.input?.file;
    if (file) {
      openFileFromURL(file.url, () => {
        dispatch(
          modalOpen('CONFIRM', {
            title: '팝업 차단',
            content: '팝업 차단이 설정되어 확인할 수 없습니다.\n차단을 해제(팝업 허용)해 주세요.',
          })
        );
      });
    }
  }
  async function downloadDocumentAttachmentFile(attachment: AttachmentInformation) {
    const response = await getDocumentsAttachment({
      workspaceId: workspaceService.getWorkspaceId(),
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      documentId: attachment.documentId!,
      attachmentId: attachment.id,
    });
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const name = attachment.participantReference.name!;

    const file = response.input?.file;
    if (file) {
      downloadFileFromURL({
        url: file.url,
        saveFileName: `${name}_${attachment.title}${file.extension}`,
      });
    }
  }

  return {
    openDocumentAttachmentFile,
    downloadDocumentAttachmentFile,
  };
}
